module.exports = __webpack_public_path__ + "img/21000.3c71f27c.jpg";